module.exports = __webpack_public_path__ + "img/Spinner.ede4bc70.svg";